import { Link } from 'react-router-dom';
import { SignalPoolCardData } from '../WatchlistDashboardService';
import AlumniRow from './AlumniRow';
import { buildReportLink, poolToWatchlistCode } from '../reportLink';

/**
 * Layer 1 Signal pool card. Faithful to the HTML mockup MINUS the two progress bars
 * (activated_pct / contactability_pct) which are deliberately deferred for v1.
 *
 * "View All N →" opens the Watchlist Report pre-filtered to this pool.
 */
const SignalPoolCard = ({ pool, instituteId, filterInstituteId }: { pool: SignalPoolCardData; instituteId: string | number; filterInstituteId?: string | null }) => (
    <div className="col">
        <div className="bg-white border h-100 rounded-4 p-4 d-flex flex-column justify-content-between shadow-sm border-primary border-opacity-25">
            <div>
                <div className="d-flex justify-content-between align-items-start mb-3">
                    <div
                        className="d-flex align-items-center justify-content-center rounded-3 font-18 bg-light"
                        style={{ width: 38, height: 38 }}>
                        {pool.icon}
                    </div>
                    <div className="text-end">
                        <div className="font-24 font-600 text-dark-blue mb-1">{pool.count}</div>
                        <div className="font-12 text-muted mb-2 lh-base">alumni in pool</div>
                    </div>
                </div>
                <div className="font-13 font-600 text-dark mb-1">{pool.label}</div>
                <div className="font-12 text-muted mb-2 lh-base">{pool.description}</div>

                <hr />
                <div className="font-10 font-600 text-uppercase text-muted mb-2">Top Alumni</div>
                <div className="d-flex flex-column gap-1">
                    {pool.top_alumni.length === 0 ? (
                        <div className="font-12 text-muted">No alumni in this pool yet</div>
                    ) : (
                        pool.top_alumni.map((alumni) => <AlumniRow key={alumni.student_id} alumni={alumni} />)
                    )}
                </div>
            </div>
            {pool.total_count_for_link > 0 && (
                <Link
                    to={buildReportLink({ institute_id: instituteId, filter_institute_id: filterInstituteId, layer: 'signal', watchlist_code: poolToWatchlistCode(pool.pool) })}
                    className="d-inline-flex align-items-center gap-1 mt-3 font-12 font-600 text-primary text-decoration-none">
                    View All {pool.total_count_for_link} <i className="bi bi-arrow-right"></i>
                </Link>
            )}
        </div>
    </div>
);

export default SignalPoolCard;
